import React, { useEffect, useState, useRef } from "react";
import notificationAudio from "./audio/inspiring-cinematic-ambient-116199.mp3";

const NotificationPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [hasShown, setHasShown] = useState(false);

  const prevMinuteRef = useRef(null);
  const soundRef = useRef(null);

  const startTone = () => {
    soundRef.current = new Audio(
      "https://res.cloudinary.com/dsmabnook/video/upload/v1768040471/Stranger_Things_Title_Sequence_HD_Netflix_xuwmpn.mp3"
    );
    soundRef.current.loop = true;

    soundRef.current
      .play()
      .then(() => console.log("Notification sound playing"))
      .catch((err) => console.warn("Audio autoplay failed:", err));
  };

  const stopTone = () => {
    if (soundRef.current) {
      soundRef.current.pause();
      soundRef.current.currentTime = 0;
      soundRef.current = null;
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const day = now.getDay();

      if (prevMinuteRef.current !== minutes) {
        setHasShown(false);
        prevMinuteRef.current = minutes;
      }

      const triggerTimes = [
        { h: 14, m: 0 },
        { h: 15, m: 0 },
        { h: 16, m: 0 },
        { h: 16, m: 50 },
      ];

      const isTrigger = triggerTimes.some(
        (t) => t.h === hours && t.m === minutes
      );

      if (isTrigger && !hasShown) {
        if (day === 5) setMessage("IT team has a demo at 5:00 PM");
        if (day === 6) setMessage("Sales team has a demo at 5:00 PM");

        if (day === 5 || day === 6) {
          setShowPopup(true);
          startTone(); // 🔥 Works like Birthday code
          setHasShown(true);

          setTimeout(() => {
            setShowPopup(false);
            stopTone(); // stop sound
          }, 60000);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [hasShown]);

  return (
    <>
      <div
        className={`modal fade ${showPopup ? "show" : ""}`}
        style={
          showPopup
            ? {
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(3px)",
              }
            : { display: "none" }
        }
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              background: "#ffffff",
              borderRadius: "18px",
              padding: "25px",
              animation: `
                  popupScale 0.3s ease-out,
                  slideInUp 0.4s ease-out,
                  notifGlow 2s infinite ease-in-out
                `,
              border: "3px solid #2eb344",
            }}
          >
            <h1
              style={{
                fontWeight: "700",
                color: "#2eb344",
                textAlign: "center",
                fontSize: "2.3rem",
              }}
            >
              📢 Demo Notification
            </h1>

            <h2
              style={{
                fontSize: "1.8rem",
                textAlign: "center",
                marginTop: "15px",
                color: "#333",
                fontWeight: 600,
              }}
            >
              {message}
            </h2>
          </div>
        </div>
      </div>

      <style>{`
          @keyframes popupScale {
            0% { transform: scale(0.7); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          @keyframes slideInUp {
            0% { transform: translateY(40px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          @keyframes notifGlow {
            0% { box-shadow: 0 0 10px #2eb344; }
            50% { box-shadow: 0 0 35px #3fd95b; }
            100% { box-shadow: 0 0 10px #2eb344; }
          }
        `}</style>
    </>
  );
};

export default NotificationPopup;
